import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const ResendMail = (props: SvgProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2232_6112)">
      <path
        d="M13.4167 8.49888C13.8251 8.26217 14.1902 7.96154 14.5 7.60946V14.5H1.5V4.75C1.5 3.85408 2.22908 3.125 3.125 3.125H7.23463C7.09596 3.46679 7.00117 3.82971 6.95404 4.20833H3.125C2.826 4.20833 2.58333 4.45154 2.58333 4.75V4.88108L6.85058 9.14888C7.46483 9.76258 8.53463 9.76258 9.14888 9.14888L9.55783 8.73992C9.93863 8.90133 10.347 9.00913 10.7744 9.05571L9.91533 9.91479C9.40346 10.4261 8.72313 10.7078 8 10.7078C7.27688 10.7078 6.59654 10.4261 6.08467 9.91479L2.58333 6.41346V13.4167H13.4167V8.49888ZM13.5434 2.45658C12.9557 1.86725 12.1465 1.5 11.25 1.5C9.45763 1.5 8 2.95763 8 4.75C8 6.54238 9.45763 8 11.25 8C12.8571 8 14.1918 6.82621 14.4513 5.29167H13.3398C13.0976 6.22333 12.257 6.91667 11.25 6.91667C10.0551 6.91667 9.08333 5.94492 9.08333 4.75C9.08333 3.55508 10.0551 2.58333 11.25 2.58333C11.848 2.58333 12.3859 2.82979 12.7759 3.22413L11.7917 4.20833H13.9583C14.2573 4.20833 14.5 3.96567 14.5 3.66667V1.5L13.5434 2.45658Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2232_6112">
        <rect
          width="13"
          height="13"
          fill="white"
          transform="translate(1.5 1.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
